import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getSmartDevicePage = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/page',
    Object.assign({}, options, {
      params
    })
  );

  export const getSmartDevicePageNew = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/pageTotal',
    Object.assign({}, options, {
      params
    })
  );

export const smartDeviceSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/elder-device/save', params, options);

export const smartDeviceUpdate = (params, options) =>
  request.post('/api/v4ward/nursinghome/elder-device/update', params, options);

  export const getSmartDeviceDetail = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/detail',
    Object.assign({}, options, {
      params
    })
  );
//设备履历-设备信息
export const getSmartDeviceResumeBasicInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/resume/basicInfo',
    Object.assign({}, options, {
      params
    })
  );

//报废
export const smartDeviceScrap = (params, options) =>
  request.post('/api/v4ward/nursinghome/elder-device/scrap', params, options);
//设备履历-使用者信息
export const getSmartDeviceResumeElderlyInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/resume/elderlyInfo',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-维修记录列表
export const getSmartDeviceResumeRepairlist = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/resume/repair/list',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-维修新增
export const smartDeviceResumeRepairSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/elder-device/repair/save', params, options);


//设备履历-保养记录列表
export const getSmartDeviceResumeUpkeeplist = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/resume/upkeep/list',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-保养新增
export const smartDeviceResumeUpkeepSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/elder-device/upkeep/save', params, options);


//设备数据-参数配置
export const getSmartDeviceDataConfig = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/data/config',
    Object.assign({}, options, {
      params
    })
  );

//设备数据-定位数据
export const getSmartDeviceDataLocation = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/data/location',
    Object.assign({}, options, {
      params
    })
  );

//设备数据-健康数据
export const getSmartDeviceDataHealth = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/elder-device/data/health',
    Object.assign({}, options, {
      params
    })
  );



export const nursinglist = (params, options) =>
request.get(
  '/api/nursing/basicInfor/nursinglist',
  Object.assign({}, options, {
    params
  })
);

//解绑
export const smartDeviceUnbind = (id) =>
  request.post('/api/v4ward/nursinghome/elder-device/unbind?id='+id);


  export const getSmartDeviceDataAlert = (params, options) =>
request.get(
    '/api/v4ward/nursinghome/elder-device/data/alert',
  Object.assign({}, options, {
    params
  })
);

export const getDicList = (params, options) =>
request.get(
    '/api//blade-system/dict/list',
  Object.assign({}, options, {
    params
  })
);

export const modelListByTypeId = (params, options) =>
request.get(
    '/api/nursing/deviceModel/modelListByTypeId',
  Object.assign({}, options, {
    params
  })
);
